import { SectionName, withTracking } from '../../../observability';
import { createBuilderModule } from '../../../builder';
import { defaultValues } from './fixtures';
import { FeaturesSection } from './FeaturesSection';
import { COLOR_KEYS, ICON_NAMES } from '../../../constants';

export default createBuilderModule(
  withTracking(FeaturesSection, { sectionName: SectionName.FeaturesSection }),
  {
    name: 'FeaturesSection',
    image: 'https://cdn.zappy.app/4687d1540f1a9cf3db47733741045378.svg',
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        required: true,
        defaultValue: defaultValues.backgroundColor,
      },
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: defaultValues.heading,
      },
      {
        name: 'description',
        type: 'richText',
        required: true,
        defaultValue: defaultValues.description,
      },
      {
        name: 'features',
        type: 'list',
        subFields: [
          {
            name: 'iconName',
            type: 'string',
            enum: Object.values(ICON_NAMES),
            required: true,
          },
          {
            name: 'heading',
            type: 'string',
            required: true,
          },
          {
            name: 'description',
            type: 'richText',
            required: true,
          },
        ],
        required: true,
        defaultValue: defaultValues.features,
      },
    ],
  },
);
